import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Dialogs, useDialogs } from '../../../../sharedComponents/src/Contexts/DialogsContext'
import AnimatedDialog from '../../../../sharedComponents/src/Dialogs/Common/AnimatedDialog'
import { analyticsManager } from '../../../../sharedComponents/src/globalHeader/services/analytics/AnalyticsManager'
import { useScreenSize } from '../../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreActions } from '../../../../store/hooks'
import StreakBanner from '../../../PuzzlesView/components/StreakBanner'
import FeedbackShareActions from '../../components/FeedbackShareActions'
import { SHARE_TYPE } from '../../functions/shareApi'

interface IProps {
    puzzleId: string
    streak: number
    feedbackMessage: string
    showStreak: boolean
    performanceGroupID: number
}

const DailyPuzzleFeedback: React.FC<IProps> = (props) => {
    const { puzzleId, streak, feedbackMessage, showStreak, performanceGroupID } = props
    const { isMobile } = useScreenSize()
    const { unregisterDialog } = useDialogs()

    const setShowFeedbackDialog = useStoreActions((state) => state.dailyPuzzleViewV2.setShowFeedbackDialog)
    const setShowStreak = useStoreActions((state) => state.dailyPuzzleViewV2.setShowStreak)
    const setFeedbackMessage = useStoreActions((state) => state.dailyPuzzleViewV2.setFeedbackMessage)

    const onCloseHandler = () => {
        analyticsManager.dispatchEvent('feedbackPopupClosed', {
            puzzleId: puzzleId || '',
            feature: 'dailyPuzzle',
        })
        unregisterDialog(Dialogs.DAILY_PUZZLE_FEEDBACK)
        setShowFeedbackDialog(false)
        setShowStreak(false)
        setFeedbackMessage('')
    }

    return (
        <AnimatedDialog
            name={Dialogs.DAILY_PUZZLE_FEEDBACK}
            borderColor="secondary.main"
            paddingLess
            onClose={onCloseHandler}
            paperProps={{
                animationOrImage: {
                    src: `/assets/animations/puzzles/daily-puzzle-feedback.lottie`,
                    verticalPosition: {
                        xs: '-190px',
                        md: '-220px',
                    },
                    horizontalPosition: {
                        xs: '-12%',
                        md: '75px',
                    },
                },
                closeIcon: {
                    verticalPosition: {
                        xs: '-85px',
                        md: '-45px',
                    },
                    horizontalPosition: {
                        xs: '0px',
                        md: '20px',
                    },
                },
            }}
        >
            <Stack
                gap={{ xs: 2, md: 3 }}
                alignItems="center"
                sx={{
                    pt: { xs: showStreak ? '0px' : '30px', md: showStreak ? '20px' : '60px' },
                    pb: { xs: '16px', md: '32px' },
                    px: { xs: '16px', md: '24px' },
                }}
            >
                {/* Content */}
                {showStreak && <StreakBanner value={streak} title="Day Streak" />}
                <Typography variant={isMobile ? 'body4' : 'body3'}>{feedbackMessage}</Typography>

                {/* Actions */}
                <FeedbackShareActions
                    puzzleId={puzzleId}
                    performanceGroupID={performanceGroupID}
                    onClose={onCloseHandler}
                    shareType={SHARE_TYPE.DAILY_PUZZLE}
                />
            </Stack>
        </AnimatedDialog>
    )
}

export default DailyPuzzleFeedback
